import { createAction, handleActions } from 'redux-actions';

import { USER_PERSONA_DISCOVERED } from '../store/actions';

export const UI_UPDATE = 'UI_UPDATE';
export const SET_DEBUG_MODE_ENABLED = 'SET_DEBUG_MODE_ENABLED';
export const SET_LOG_LEVEL = 'SET_LOG_LEVEL';
export const SET_ANALYTICS_ENABLED = 'SET_ANALYTICS_ENABLED';

// selectors
export const getWindowWidth = (state: any) => state.ux.windowWidth;
export const getSnackbarMessage = (state: any) =>
  state.ux.snackbar.snackbarMessage;
export const getSnackbarOpen = (state: any) => state.ux.snackbar.snackbarOpen;
export const selectDebugModeEnabled = (state: any) =>
  state.ux.debug_mode_enabled;
export const selectAnalyticsEnabled = (state: any) =>
  state.ux.analytics_enabled;
export const selectLogLevel = (state: any) => state.ux.log_level;

// actions
export const updateUi = createAction(UI_UPDATE);
export const setDebugModeEnabled = createAction<boolean>(
  SET_DEBUG_MODE_ENABLED
);
export const setAnalyticsEnabled = createAction<boolean>(SET_ANALYTICS_ENABLED);
export const setLogLevel = createAction<'debug' | 'info' | 'log'>(
  SET_LOG_LEVEL
);

// reducer
const initialState = {
  /**
   * @name _legacy_persona
   * @description Legacy form of persona still used in some views
   * @deprecated
   */
  _legacy_persona: null,

  persona: null, // taken from the token to normalize use between us and backend,

  fontSize: 12,
  windowWidth: window.innerWidth,
  debug_mode_enabled: false,
  analytics_enabled: true,
  log_level: undefined,
};

const UxReducer = handleActions(
  {
    [UI_UPDATE]: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },

    [USER_PERSONA_DISCOVERED]: (state, action) => {
      const { persona, _legacy_persona } = action.payload;

      return {
        ...state,
        persona,
        _legacy_persona,
      };
    },

    [SET_DEBUG_MODE_ENABLED]: (state, action) => {
      return {
        ...state,
        debug_mode_enabled: action.payload as unknown as boolean,
      };
    },

    [SET_ANALYTICS_ENABLED]: (state, action) => {
      return {
        ...state,
        analytics_enabled: action.payload as unknown as boolean,
      };
    },

    [SET_LOG_LEVEL]: (state, action) => {
      return {
        ...state,
        log_level: action.payload as unknown as
          | 'debug'
          | 'info'
          | 'log'
          | undefined,
      };
    },

  },
  initialState
);

export default UxReducer;
